import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("polyline", {
  points: "3 6 5 6 21 6"
}), ___EmotionJSX("path", {
  d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
}), ___EmotionJSX("line", {
  x1: "10",
  y1: "11",
  x2: "10",
  y2: "17"
}), ___EmotionJSX("line", {
  x1: "14",
  y1: "11",
  x2: "14",
  y2: "17"
}));
export default SVG;